import { graphql, useStaticQuery } from 'gatsby';
import React, { ReactElement } from 'react';
import { Headline, Link, Text } from '../../components';
import { track } from '../../utilities';
import LibraryThumbnail from '../library-thumbnail';

// Displays the 3 most recent items added to the Library
export default function LibraryNew(): ReactElement {
  const data = useStaticQuery(graphql`
    query LibraryNewQuery {
      allStrapiLibraryPost(sort: { date: DESC }, limit: 6) {
        nodes {
          title
          url
          categories {
            name
          }
          author {
            name
            image {
              url
            }
          }
        }
      }
    }
  `);

  const handlePostClick = (category, title, url) => (e) => {
    track('Library post clicked', {
      category,
      title,
      url,
    });
  };

  return (
    <div className="mb-16 grid auto-rows-fr grid-cols-[repeat(auto-fill,261px)] gap-8 max-nav:grid-cols-1 [&_.library-thumbnail]:h-10 [&_.library-thumbnail]:w-10">
      {data.allStrapiLibraryPost.nodes.map(
        ({ url, title, author, categories }) => {
          return (
            <Link
              key={url}
              onClick={handlePostClick(categories[0].name, title, url)}
              className="overflow-hidden rounded-lg border border-neutral-gray-100 pt-6 pr-6 pb-10 pl-6 no-underline! transition-[border] duration-200 ease-[ease] focus-within:border-neutral-gray-300 hover:border-neutral-gray-300 focus:border-neutral-gray-300 max-nav:pb-6"
              href={url}
              target="_blank"
              aria-label={title}
              rel="noopener noreferrer">
              <LibraryThumbnail
                url={
                  author.image
                    ? author.image.url
                    : 'https://res.cloudinary.com/stark-lab/image/upload/v1669148590/default_author_f18d200691.png'
                }
                name={author.name}
              />

              <Text
                level="mono"
                color="purple"
                className="mt-3 mb-2 line-clamp-2">
                {categories[0].name}
              </Text>

              <Headline level="4" className="mb-2 line-clamp-3">
                {title}
              </Headline>
            </Link>
          );
        }
      )}
    </div>
  );
}
